const READOUT = [
  'READING S&P 500',
  '500 NAMES',
  'REBALANCED DAILY',
  '20–30 HOLDINGS',
  'GLASS BOX',
  'VERSIONED · HASHED · RECONSTRUCTABLE',
  'NO HUMAN IN THE DAILY TRADES',
];

/**
 * Top instrument strip. Sets the "this is a live machine" tone before anything
 * else loads. Mono, hairline, quiet — a status readout, not a marketing banner.
 */
export function StatusRail() {
  return (
    <div className="border-b border-white/8 bg-[color:var(--nq-bg-deep)]">
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-6 py-2">
        <span className="mkt-live-dot inline-block size-1.5 rounded-full bg-[color:var(--nq-up)]" />
        <span className="mkt-mono shrink-0 text-[10px] uppercase tracking-[0.22em] text-[color:var(--nq-up-bright)]">
          System live
        </span>
        <div className="mkt-fade-r hidden min-w-0 flex-1 items-center gap-3 overflow-hidden sm:flex">
          {READOUT.map((item) => (
            <span
              key={item}
              className="mkt-mono flex shrink-0 items-center gap-3 text-[10px] uppercase tracking-[0.18em] text-muted-foreground"
            >
              <span aria-hidden className="text-white/20">
                /
              </span>
              {item}
            </span>
          ))}
        </div>
        <span className="mkt-mono ml-auto shrink-0 text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
          Est. 2026
        </span>
      </div>
    </div>
  );
}
